export type DetailRow = Record<string, any>;

export interface WorkOrderDetailState {
  order: DetailRow | null;
  project: DetailRow | null;
  zone: DetailRow | null;
  phase: DetailRow | null;
  boqItem: DetailRow | null;
  team: DetailRow | null;
  lead: DetailRow | null;
  tasks: DetailRow[];
  members: DetailRow[];
  materials: DetailRow[];
  equipment: DetailRow[];
  checklists: DetailRow[];
  photos: DetailRow[];
  logs: DetailRow[];
  inspections: DetailRow[];
}

export const emptyWorkOrderDetail: WorkOrderDetailState = {
  order: null,
  project: null,
  zone: null,
  phase: null,
  boqItem: null,
  team: null,
  lead: null,
  tasks: [],
  members: [],
  materials: [],
  equipment: [],
  checklists: [],
  photos: [],
  logs: [],
  inspections: [],
};

export interface WorkOrderMaterial {
  id: string;
  material_name: string;
  planned_qty: number;
  issued_qty: number;
  used_qty: number;
  waste_qty: number;
  unit: string;
  status_code: string;
}

export interface WorkOrderEquipment {
  id: string;
  equipment_name: string;
  planned_hours: number;
  actual_hours: number;
  status_code: string;
}

export interface WorkOrderDetailViewModel {
  id: string;
  code: string;
  title: string;
  description: string;
  status: string;
  statusLabel: string;
  priority: string;
  priorityLabel: string;
  workTypeLabel: string;
  projectId: string;
  companyId: string;
  projectName: string;
  zoneName: string;
  phaseName: string;
  boqName: string;
  teamName: string;
  leadName: string;
  leadEmail: string;
  leadAvatar: string | null;
  leadRoleName: string;
  leadRoleCode: string;
  progress: number;
  plannedStart: string | null;
  plannedEnd: string | null;
  actualStart: string | null;
  actualEnd: string | null;
  dueDate: string | null;
  estimatedCost: number;
  actualCost: number;
  area_m2: number | null;
  tree_count: number | null;
  lawn_area_m2: number | null;
  shrub_area_m2: number | null;
  hedge_length_m: number | null;
  material_quantity: string | null;
  scheduled_date: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  tasks: DetailRow[];
  members: DetailRow[];
  materials: WorkOrderMaterial[];
  equipment: WorkOrderEquipment[];
  checklists: DetailRow[];
  photos: DetailRow[];
  logs: DetailRow[];
  inspections: DetailRow[];
}
